import { colors } from '../foundation';

type Props = {
  color:
    | (typeof colors.red)['100']
    | (typeof colors.red)['25']
    | (typeof colors.neutral)[10]
    | typeof colors.primary.white;
};

const ArrowRight = ({ color }: Props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
      <path
        d="M6.46967 11.6023C6.17678 11.8219 6.17678 12.1781 6.46967 12.3977C6.76256 12.6174 7.23744 12.6174 7.53033 12.3978L11.5303 9.39778C11.671 9.29226 11.75 9.14916 11.75 8.99998C11.75 8.85081 11.671 8.70778 11.5303 8.60226L7.53033 5.60225C7.23744 5.38258 6.76256 5.38258 6.46967 5.60225C6.17678 5.82192 6.17678 6.17808 6.46967 6.39775L9.93934 8.99998L6.46967 11.6023Z"
        fill={color}
      />
    </svg>
  );
};
export default ArrowRight;
